import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "side" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "content"
}
const _hoisted_4 = {
  key: 1,
  class: "content"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "你在找哪種運動呢？", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "你在找哪些地區呢？", -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal wrap",
    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.stepWrap)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.$style.filter, !_ctx.filterStep ? _ctx.$style.process : _ctx.$style.active]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchFilter(_ctx.FilterStep.Sport)))
        }, [
          _createElementVNode("p", null, _toDisplayString(_ctx.sportName ? _ctx.sportName : '運動'), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.line)
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.$style.filter, _ctx.filterStep && _ctx.$style.process]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchFilter(_ctx.FilterStep.Dists)))
        }, [
          _createElementVNode("p", null, [
            (!_ctx.tempDists.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, " 地區 "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempDists, (distId, i) => {
              return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(_ctx.districtName(distId, true)), 1))
            }), 128))
          ])
        ], 2)
      ], 2)
    ]),
    (_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.contentWrap)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.title)
            }, [
              _createElementVNode("h3", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchFilter(_ctx.FilterStep.Sport))),
                class: _normalizeClass({ [_ctx.$style.selected]: _ctx.sportStep })
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass({ [_ctx.$style.subtitle]: _ctx.sportName })
                }, "運動類型", 2),
                _createTextVNode(" " + _toDisplayString(_ctx.sportName), 1)
              ], 2),
              _createElementVNode("h3", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchFilter(_ctx.FilterStep.Dists))),
                class: _normalizeClass({ [_ctx.$style.selected]: !_ctx.sportStep })
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass({ [_ctx.$style.subtitle]: _ctx.tempDists.length !== 0 })
                }, " 運動地區 ", 2),
                _createTextVNode(" " + _toDisplayString(_ctx.distStr), 1)
              ], 2)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.wrap),
              style: _normalizeStyle({ marginLeft: _ctx.sportStep ? '0' : '-100%' })
            }, [
              _createElementVNode("div", null, [
                _renderSlot(_ctx.$slots, "sport")
              ]),
              _createElementVNode("div", null, [
                _renderSlot(_ctx.$slots, "dist")
              ])
            ], 6)
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.contentWrap)
          }, [
            (_ctx.sportStep)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.$style.title, 'title'])
                  }, _hoisted_6, 2),
                  _renderSlot(_ctx.$slots, "sport")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.$style.title, 'title'])
                  }, _hoisted_8, 2),
                  _renderSlot(_ctx.$slots, "dist")
                ], 64))
          ], 2)
        ]))
  ]))
}